import { DateTimePicker } from '@mantine/dates';
import React from 'react';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';

interface Props {
  question: FlowsQuestion;
}

const DatetimeInputComponent: React.FC<Props> = ({ question }) => {
  const {
    field: { value, onBlur, onChange },
  } = useFlowInputComponent({
    question,
  });

  const dateString = value as string;

  const handleOnBlur = () => {
    onBlur({
      name: question.id,
      value: dateString,
    });
  };

  const handleOnChange = (date: Date | null) => {
    onChange({
      name: question.id,
      value: date?.toISOString(),
    });
  };

  return (
    <DateTimePicker
      value={dateString ? new Date(dateString) : null}
      onChange={handleOnChange}
      onBlur={handleOnBlur}
    />
  );
};

export default DatetimeInputComponent;
